const wuProgressBar = document.querySelectorAll('.wu-progress-bar-gamma')

const changeProgressBar = (count, specificFn) => {
    Array.from(wuProgressBar).forEach((bar, index) => {
        if(index <= count) {
            bar.classList.add('bk-green', 'bdr-color-green')
            bar.classList.remove('bk-grey-12', 'bdr-color-grey-02')
        } else {
            bar.classList.remove('bk-green', 'bdr-color-green')
            bar.classList.add('bk-grey-12', 'bdr-color-grey-02')
        }
    })
    
    specificFn && specificFn(count)
}

window.rmoFormData = window.rmoFormData || {}
window.rmoFormData.changeProgressBar = changeProgressBar